<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('fulfillment_ptl_supplied.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text tools-view-height mx-1" color="secondary" :to="'/ptl-fulfillment/assemble'" style="max-width: 40px !important; min-width: 40px !important" >
                                <v-icon class="material-icons-outlined" small>send_and_archive</v-icon>
                            </v-btn>
                        </template>

                        <span>{{$t('fulfillment_ptl_supplied.assemble')}}</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <v-data-table class="px-0 my-2"
                                no-results-text="No hay resultados"
                                :headers="headers"
                                :items="props.items"
                                :search="props.search"
                                calculate-widths
                                :footer-props="{
                                    'items-per-page-text': this.$t('datatable.shown'),
                                    showFirstLastPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    pageText: '{0}-{1} ' + this.$t('datatable.of') + ' {2} ' + this.$t('datatable.results'),
                                    'show-current-page': true,
                                    'items-per-page-options': typeof props.rowsPP === 'undefined' ? [15, 25, 50] : props.rowsPP}"
                                :page="1"
                                :mobile-breakpoint="0"
                                item-key="id"
                            >
                                <template v-slot:item.actions="{ item }">
                                    <v-tooltip top v-for="(action, i) of item.actions" :key="i">
                                        <template v-slot:activator="{ on }">
                                            <v-btn x-small v-if="!('link' in action)" icon @click="methodHandler(action.method, item.parameters)" :disabled="action.method === null">
                                                <v-icon class="material-icons-outlined" :color="action.icon.color" v-on="on">{{ action.icon.icon }}</v-icon>
                                            </v-btn>
                                            <v-btn x-small v-else icon text :to="action.link" :disabled="action.link === null">
                                                <v-icon class="material-icons-outlined" :color="action.icon.color" v-on="on">{{ action.icon.icon }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ action.name }}</span>
                                    </v-tooltip>
                                </template>

                                <!-- Id dot in cod orders in process. INDEX -->
                                <template v-slot:item.prepared="{ item }"> 
                                    <td v-if="item.prepared == 1" style="text-align:center !important">
                                        <v-icon color="success2" small> fiber_manual_record </v-icon> 
                                    </td>
                                    <td v-else style="text-align:center">
                                        <v-icon class="material-icons-outlined" small color="#a5a5a5"> fiber_manual_record </v-icon> 
                                    </td>
                                </template>
                                
                                <v-data-footer :items-per-page-options="[]"></v-data-footer>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            </v-container>     
            <v-dialog v-model="modalRestore" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('fulfillments_cod_in_process.restore_modal.restore') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('fulfillments_cod_in_process.restore_modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalRestore = false">{{ $t('fulfillments_cod_in_process.no') }}</v-btn>
                            <v-btn color="error" @click="restoreOrder">
                                {{ $t('fulfillments_cod_in_process.yes_restore') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalDetail" persistent max-width="90%" v-if="orderToShow != null">
                <v-card style="min-width: 700px !important">
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('fulfillment_ptl_pendings.order_details.header') }} {{ this.orderToShow.uniqueOrderNumber }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillment_ptl_pendings.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.order_number") }}</label> <label>{{ this.orderToShow.unique_order_number }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.date") }}</label> <label>{{ this.orderToShow.created_at }}</label></div>
                    <div class="detail_content1" v-if="shipping_service != 'otra'"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.shipping_service }}</label></div>
                    <div class="detail_content1" v-if="shipping_service == 'otra'"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.external_shipping_service }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.invoice") }}</label> <label>{{ this.orderToShow.invoice }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.client != null"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.client") }}</label> <label>{{ this.orderToShow.client.name }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.cod") }}</label> <label>{{ this.orderToShow.total }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.buyer") }}</label> <label>{{ this.orderToShow.consignee.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.state") }}</label> <label>{{ this.orderToShow.consignee.state }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.municipality") }}</label> <label>{{ this.orderToShow.consignee.municipality }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.neighborhood") }}</label> <label>{{ this.orderToShow.consignee.neighborhood }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.address") }}</label> <label>{{ this.orderToShow.consignee.street }} {{ this.orderToShow.consignee.externalNumber }} {{ this.orderToShow.consignee.internalNumber }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillment_ptl_pendings.zip_code") }}</label> <label>{{ this.orderToShow.consignee.zipcode }}</label></div>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillment_ptl_pendings.products') }}</label></div>
                    <!-- Shipments -->
                    <span v-if="orderToShow.shipment_product_detail != null">
                        <div v-for="(product, i) of orderToShow.shipment_product_detail" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.product.sku }}</label> <label>{{ product.quantity }}</label></div>
                    </span>
                    <!-- External Shipments -->
                    <span v-if="orderToShow.products != null">
                        <div v-for="(product, i) of orderToShow.products" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.sku }}</label> <label>{{ product.quantity }}</label></div>
                    </span>

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" outlined color="secondary" text @click="modalDetail = false">{{ $t('fulfillment_ptl_pendings.go_back') }}</v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { HttpShipmentRepository } from '../../infrastructure/shipment_repository';
import { ptlSuppliedUseCase } from '../../application/use_cases/ptl_supplied_use_case';
import { ptlShowOrderInfoUseCase } from '../../application/use_cases/ptl_show_order_info_use_case';

export default {
    computed: {
        headers(){
            return [
                { text: this.$t('fulfillment_ptl_supplied.order'), align: "center", value: 'unique_order_number', class: 'text-uppercase' },
                { text: this.$t('fulfillment_ptl_supplied.customer'), align: "center", value: 'client.name', class: 'text-uppercase' },
                { text: this.$t('fulfillment_ptl_supplied.shipment_number'), align: "center", value: 'shipment_number', class: 'text-uppercase' },
                { text: this.$t('fulfillment_ptl_supplied.date'), align: "center", value: 'created_at', class: 'text-uppercase' },
                { text: this.$t('fulfillment_ptl_supplied.prepared'), align: "center", value: 'prepared', class: 'text-uppercase' },
                { text: this.$t('fulfillment_ptl_supplied.value'), align: "center", value: 'total', class: 'text-uppercase' },
                { text: this.$t('fulfillment_ptl_supplied.actions'), align: "center", value: 'actions', class: 'text-uppercase' },
            ];
        } 
    },
    data(){
        return {
            shipping_service: this.$route.params.shipping_service,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDelete: false,
            modalDetail: false,
            modalRestore: false,
            orderToShow: "",
            orderToRestore: "",
            props: {
                search: '',
                items: [],
            },
        }
    },
    mounted(){
        this.$store.state.module = "headers.fulfillment_ptl_" + this.shipping_service + "_supplied";

        this.index();
    },
    methods: {
        methodHandler(object, params){
            this[object](params)
        },
        async index(){
            try{
                this.props.items = [];

                if(this.shipping_service != "eon") {
                    const result = await ptlSuppliedUseCase(this.shipping_service, HttpShipmentRepository);
                    this.props.items = result;
                }
            }
            catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async showDetails(order){
            this.orderToShow = order;
        
            try{
                if(this.shipping_service == "eon"){
                    console.log("OKOOk")
                }
                else {
                    const result = await ptlShowOrderInfoUseCase(order.id, HttpShipmentRepository);
                    this.orderToShow = result;

                    this.modalDetail = true;
                }
            }
            catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        askRestore(order){
            this.modalRestore = true;
            this.orderToRestore = order;
        },
        restoreOrder(){
            this.$store.state.loaderProps.visible = true;
            if(this.orderToRestore != ''){
                if(this.shipping_service == "eon"){
                    const lsToken = localStorage.getItem("access_token");
                    this.$http.put(this.$store.state.chronosApi + 'external_shipment/restore/' + this.orderToRestore.id, {headers: {Authorization: lsToken}})
                    .then((response) => {
                        if(response.status === 200) {
                            this.orderToRestore = '';
                            this.modalRestore = false;
                            this.snackbar = {
                                visible: true,
                                color: 'success2',
                                text: this.$t('fulfillments_cod_sent.restored')
                            }
                            this.index();
                        }
                    }).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                        this.$store.state.loaderProps.visible = false;
                    })
                }
                else {
                    const lsToken = localStorage.getItem("access_token");
                    this.$http.put(this.$store.state.chronosApi + 'shipment/restock/' + this.orderToRestore.id, {}, { headers: { Authorization: lsToken } })
                    .then((response) => {
                        if(response.data.code === 200) {
                            this.orderToRestore = '';
                            this.modalRestore = false;
                            this.snackbar = {
                                visible: true,
                                color: 'success2',
                                text: this.$t('advanced_fulfillment_sent.restored')
                            }
                            this.index();
                        }
                    }).catch((err) => {
                        console.log(err);
                    }).finally(() => {
                        this.$store.state.loaderProps.visible = false;
                    })
                }
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: "error"
                }
            }
        },
    },
    watch:{
        '$route.params.shipping_service': function() {
            location.reload();
        }
    }
}
</script>

<style>

</style>